import React from "react";

export function KpiCard({ label, value, hint, tone, testId }) {
  const styles = {
    yellow: "bg-[var(--mp-yellow)] text-[var(--mp-ink)] border-[var(--mp-ink)]",
    ink: "bg-[var(--mp-ink)] text-white border-[var(--mp-ink)]",
    paper: "bg-white text-[var(--mp-ink)] border-[var(--mp-ink)]",
  };
  return (
    <div
      data-testid={testId}
      className={`rounded-3xl border ${styles[tone]} p-5 shadow-brutal-sm`}
    >
      <div className="text-[10px] font-bold uppercase tracking-[0.24em] opacity-90">
        {label}
      </div>
      <div className="font-display text-5xl tracking-tighter mt-1">{value}</div>
      {hint && <div className="text-[11px] mt-1 opacity-75">{hint}</div>}
    </div>
  );
}
